"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matrixFromRowsDependencies = void 0;
var _dependenciesFlattenGenerated = require("./dependenciesFlatten.generated.js");
var _dependenciesMatrixGenerated = require("./dependenciesMatrix.generated.js");
var _dependenciesSizeGenerated = require("./dependenciesSize.generated.js");
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var matrixFromRowsDependencies = exports.matrixFromRowsDependencies = {
  flattenDependencies: _dependenciesFlattenGenerated.flattenDependencies,
  matrixDependencies: _dependenciesMatrixGenerated.matrixDependencies,
  sizeDependencies: _dependenciesSizeGenerated.sizeDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createMatrixFromRows: _factoriesAny.createMatrixFromRows
};